/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Select, Button, Row, Col, message } from 'antd';
import { DmsTab } from 'Components';
import { add2, getListSelect, getDetail } from '../../service/customer';
import { sKeylist } from '../../service/dictionary/dataitem';
import { allChildren } from '../../service/zone';
import { peopleList as employee } from '../../service/people';
import { categoryTree } from '../../service/category';
import { getProductList2, getSubStoreList } from '../../service/product';
import { showSpin, hideSpin, openNotice } from 'Utils';
const FormItem = Form.Item;
const { TextArea } = Input;

class ProductCustomerAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: parseInt(this.props.params.productId, 10),
      substoreId: [],
      detail: {
        code: '',
        name: '',
        supplier: '',
        proType: '',
        unit: '',
        showPrice: '',
        packageQuantity: '',
        takeEffect: '',
        otherInputNum: '',
        substoreId: '',
        remark: ''
      },
      options: [],//归属区域
      channels: [],//上级渠道
      employee: [],//所属业务员
      channel_rank: [],//渠道等级
      channel_type: [],//渠道类型
      channel_type2: [],//渠道类型
      product_categoryTree: [], //产品类型
    };
  }

  componentWillMount() { //准备数据
    const self = this;
    getSubStoreList({ removeFlag: 0, p: 1, s: 1000 }).then(res => { //渠道类型
      let arr = res.data.map(x => {
        return {
          name: x.subStoreName,
          sKey: x.id
        }
      });
      self.setState({ channel_type2: arr || [] })
    })
    categoryTree({}).then(res => { //归属区域
      if (res.data && res.data.length > 0) {
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ product_categoryTree: res.data });
          }
        }, 200);
      }
    });
    allChildren({ id: 0 }).then(res => { //归属区域
      if (res.data && res.data.length > 0) {
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ options: res.data });
          }
        }, 200);
      }
    });
    getListSelect().then(res => { //上级渠道
      if (res.data && res.data.length > 0) {
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ channels: res.data });
          }
        }, 200);
      }
    });
    sKeylist({ sKey: 'channel_rank' }).then(res => {
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ channel_rank: res.data || [] })
        }
      }, 200);
    })
    sKeylist({ sKey: 'product_unit' }).then(res => {
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ channel_type: res.data || [] })
        }
      }, 200);
    })

    employee({ status: 1 }).then(res => { //所属业务员
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ employee: res.data || [] })
        }
      }, 200);
    })
    getProductList2({
      name: '',
      active: '',
      s: 10,
      p: 1,
      startCreatedDate: '',
      endCreatedDate: '',
    }).then(function (result) {
      if (result && result.code == 200) {
        var substoreIds = new Array();
        self.setState({
          'substoreId': substoreIds,
        });
      } else {
        openNotice('error', '数据获取失败', '');
      }
    });
  }

  componentDidMount() {
    this.mounted = true;
    if (this.state.id > 0) {
      getDetail({ id: this.state.id }).then(res=> {
        if (res.code === 200) {
          const data = res.data;
          this.setState({
            detail: data
          });
        }
      });
    }
  }

  cancelHandle() {
    hashHistory.goBack()
  }
  /*输入框取整限制*/
    controlpoint =(e)=> {
   // ^(-)*(\d+)\.(\d\d).*$
      //  zhengque
   // ^(\d+)\.(\d).*$
    // ^-?(\d+)\.(\d).*$
        const reg = /^(\d+)\.(\d).*$/;
        e.target.value = e.target.value.replace(reg,"$1$2.$3");
        this.props.form.setFieldsValue({
            qualityScoreStart: e.target.value
        });

    }


  submitHandle() {
    const self = this;
    const { validateFields, getFieldsValue } = this.props.form;

    validateFields((errors) => {//表单校验
      if (errors) {
        return
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue() //获取用户输入
      };
      //判断装箱数
        if(data.packageQuantity  <= 0 ){
            openNotice('error', '提示', '装箱数必须大于0');
            return
        }
      if (data.takeEffect == 'Y') {
        if (data.otherInputNum) {
          if (!data.substoreId) {
            openNotice('error', '提示', '请选择子库存');
            return
          }
        }

      //console.log(data.packageQuantity);

        if (data.subsotreName) {
          if (!data.otherInputNum) {
            openNotice('error', '提示', '请输入杂项入库数量!');
            return;
          } else if (data.otherInputNum <= 0) {
            openNotice('error', '提示', '入库数量必须大于0!');
            return;
          }
        }
      }
      const result = {
        ...data,
        channelType: data.channelType ? parseInt(data.channelType, 10) : null,
        channelType2: data.subsotreName ? parseInt(data.subsotreName, 10) : null
      }
      showSpin();
      if (self.state.id) {
        delete result.contacts;
        delete result.contactsMobile;
        add2({ ...result, id: self.state.id }).then(res => {
          hideSpin();
          message[res.data ? 'success' : 'error'](res.message);
          res.data && hashHistory.goBack()
        })
      } else {
        add2(result).then(res => {
          hideSpin();
          message[res.data ? 'success' : 'error'](res.message);
          res.data && hashHistory.goBack()
        })
      }
    })
  }

  render() {
    const { detail, id, channel_type2, channel_type } = this.state;
    const { getFieldDecorator } = this.props.form;
    return <div className="dms-body">
      <DmsTab options={[`${id > 0 ? '编辑产品' : '新建产品'}`]} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="物料编码：" hasFeedback>
                {getFieldDecorator('code', {
                  initialValue: detail.code || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入物料编码'
                    }
                  ],
                })(<Input placeholder="请输入物料编码" disabled={!!this.state.id} />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="物料描述：" hasFeedback>
                {getFieldDecorator('name', {
                  initialValue: detail.name || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入物料描述'
                    }
                  ],
                })(<Input placeholder="请输入物料描述" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="供应商：" hasFeedback>
                {getFieldDecorator('supplier', {
                  initialValue: detail.supplier || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入供应商'
                    }
                  ],
                })(<Input placeholder="请输入供应商" />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="物料类别：" hasFeedback>
                {getFieldDecorator('proType', {
                  initialValue: detail.proType || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入物料类别'
                    }
                  ],
                })(<Input placeholder="请输入物料类别" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="channelTypeBox">
                <FormItem label="单位：">
                  {getFieldDecorator('unit', {
                    initialValue: detail.unit || '',
                    rules: [
                      {
                        required: true,
                        message: '请输入单位'
                      },
                    ],
                  })(<Select
                    showSearch
                    optionFilterProp="children"
                    notFoundContent="无法找到"
                    getPopupContainer={() => document.getElementById('channelTypeBox')}
                  >
                    {channel_type.map(item=><Select.Option value={item.name} key={item.id}>{item.name}</Select.Option>)}
                  </Select>)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="价格：" hasFeedback>
                {getFieldDecorator('showPrice', {
                  initialValue: detail.showPrice || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入价格'
                    }
                  ],
                })(<Input placeholder="请输入价格" type="number" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="装箱数：" hasFeedback>
                {getFieldDecorator('packageQuantity', {
                  initialValue: detail.packageQuantity || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入装箱数'
                    }
                  ],
                })(<Input placeholder="请输入装箱数" type="number"   name="qualityScoreStart"  onChange={this.controlpoint}/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="有效性">
                {getFieldDecorator('takeEffect', {
                  initialValue: detail.takeEffect,
                  rules: [
                    {
                      required: true,
                      message: '请选择是否生效'
                    },
                  ]
                })(<Select>
                  <Select.Option value='Y'>是</Select.Option>
                  <Select.Option value='N'>否</Select.Option>
                </Select>)}
              </FormItem>
            </Col>
          </Row>
          {this.state.id ? null :
            <Row gutter={16}>
              <Col className="gutter-row" span={12}>
                <FormItem label="杂项入库数量：" hasFeedback>
                  {getFieldDecorator('otherInputNum', {
                    initialValue: detail.otherInputNum || '',
                    rules: [
                      {
                        required: false,
                        message: '请输入杂项入库数'
                      }
                    ],
                  })(<Input placeholder="请输入杂项入库数" type="number" />)}
                </FormItem>
              </Col>
              <Col className="gutter-row" span={12}>
                <div id="channelTypeBox2">
                  <FormItem label="目标子库：">
                    {getFieldDecorator('substoreId', detail && detail.subsotreName ? {
                      initialValue: detail.substoreId + '',
                      rules: [
                        {
                          required: false,
                          message: '请选择目标子库'
                        },
                      ],
                    } : {
                      rules: [
                        {
                          required: false,
                          message: '请选择目标子库'
                        },
                      ],
                    })(<Select
                      allowClear
                      style={{ width: '100%' }}
                      getPopupContainer={() => document.getElementById('channelTypeBox2')}
                      placeholder="请选择目标子库"
                    >
                      {
                        channel_type2.map((item, index) => {
                          return <Select.Option key={index + ''} value={item.sKey + ''}>{item.name}</Select.Option>
                        })
                      }
                    </Select>)}
                  </FormItem>
                </div>
              </Col>
            </Row>
          }
          <Row>
            <Col className="gutter-row">
              <FormItem label="备注">
                {getFieldDecorator('remark', {
                  initialValue: detail.remark,
                  rules: [
                    {
                      required: false,
                      message: '请输入备注'
                    },
                  ],
                })(
                  <TextArea rows={3} />
                )}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  }
}
export default Form.create()(ProductCustomerAdd)


// WEBPACK FOOTER //
// ./src/routes/productCustomer/add.js